import React from "react";
import {Table, Button, FormControl, Glyphicon} from "react-bootstrap";
import PaginationBar from "../../PaginationBar";
import {validateEmail} from "tools";

class EmailRow extends React.Component {
	state = {
		email: null
	};

	constructor(props, context) {
		super(props, context);

		this.state = {
			email: this.props.email
		};

		this.handleChange = this.handleChange.bind(this);
	}

	componentDidMount() {
		this.setState({email: this.props.email});
	}

	UNSAFE_componentWillReceiveProps(props) {
		this.setState({email: props.email});
	}

	handleChange(e) {
		const {name, value} = e.target;
		this.setState({[name]: value});
	}

	render() {
		const {onChange, onDelete} = this.props;
		const {email} = this.state;

		return (
			<tr>
				<td>
					<FormControl type="text" value={email || ''} name="email" style={{color: validateEmail(email) ? 'inherit' : 'red'}}
						onChange={this.handleChange}
						onBlur={e => onChange(email)}
					/>
				</td>
				<td>
					<span style={{color: 'red'}}>{validateEmail(email) ? null : 'Некорректный адрес'}</span>
				</td>
				<td>
					<Button bsSize="small" onClick={onDelete}><Glyphicon glyph="trash"/></Button>
				</td>
			</tr>
		);
	}
}

class CreateList extends React.Component {
	state = {
		activePage: 1
	};

	componentDidMount() {
		this.setState({
			activePage: 1
		});
	}

	render() {
		const ticketOnPage = 100;
		const {onDelete, onChange} = this.props;
		var {emails} = this.props;
		const {activePage} = this.state;

		emails = emails.sort((a, b) => validateEmail(a) - validateEmail(b));
		var emailsFiltered = emails;
		var pageCount = Math.ceil(emailsFiltered.length / ticketOnPage);

		emailsFiltered = emailsFiltered.slice((activePage - 1) * ticketOnPage, activePage * ticketOnPage);

		return (
			<section>
				<Table>
					<thead>
					<tr>
						<th>eMail</th>
						<th width="180" />
						<th width="40"> </th>
					</tr>
					</thead>
					<tbody>
					{emailsFiltered.map((email, index) =>
						<EmailRow email={email} key={index} onChange={newEmail => onChange(email, newEmail)} onDelete={e => onDelete(email)}/>
					)}
					</tbody>
				</Table>

				<PaginationBar
					pageCount={pageCount}
					activePage={activePage}
					onSelect={(activePage) => this.setState({activePage})}
				/>
			</section>
		);
	}

}

export default CreateList;
